import { motion, AnimatePresence } from 'framer-motion';
import styles from './InquiryModal.module.css';

const InquiryModal = ({ message, type, onClose }) => {
  return (
    <AnimatePresence>
      {message && (
        <motion.div
          className={`${styles.modal} ${styles[type]}`}
          initial={{ opacity: 0, scale: 0.95 }}
          animate={{ opacity: 1, scale: 1 }}
          exit={{ opacity: 0, scale: 0.95 }}
          transition={{ duration: 0.25 }}
        >
          <p className={styles.message}>{message}</p>
          <button className={styles.closeBtn} onClick={onClose}>
            Close
          </button>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default InquiryModal;